import { Component, Input, NgZone, OnDestroy } from "@angular/core";
import moment from 'moment';
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { ModalDialogComponent } from "../../../../common/modal/modalDialog.component";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { OffersInNegotiationData, OffersInNegotiationDetail, OffersInNegotiationService, OffersInNegotiationServiceData } from "../../services/offersInNegotiationKpi/offersInNegotiation.service";
import { BarChartData, BarChartDataset } from "../../../../dashboardCommon/components/cardContents/barChart.component";
import { ChartDropdownOption } from "../../../../dashboardCommon/components/cardContents/chartDropdown.component";
import { ColumnDefinition, TextColumnDefinition } from "../../../../dashboardCommon/components/cardDetails/datatable.component";
import { SingleSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class OffersInNegotiationEvolutionDOData {
    public barChartData: BarChartData;

    constructor(barChartData: BarChartData) {
        this.barChartData = barChartData;
    }
}

export class OffersInNegotiationDODetailData {
    public columnDefinitions: ColumnDefinition[];
    public tabledata: any[][];

    constructor(columnDefinitions: ColumnDefinition[], tabledata: any[][]) {
        this.columnDefinitions = columnDefinitions;
        this.tabledata = tabledata;
    }
}


@Component({
    selector: 'offers-in-negotiation-evolution-do-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class OffersInNegotiationEvolutionDOKpiServiceHostComponent extends SingleSummaryDetailKpiServiceHost<OffersInNegotiationService, OffersInNegotiationServiceData, ChartDropdownOption[], OffersInNegotiationDODetailData>
    implements OnDestroy {
    public getClassName() { return "OffersInNegotiationEvolutionDOKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;
    @Input() public detailDialog: ModalDialogComponent;
    @Input() public messageDialog: ModalDialogComponent;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryDetailService: OffersInNegotiationService) {
        super(zone, logger, summaryDetailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: OffersInNegotiationServiceData, updateRequested: Boolean): ChartDropdownOption[] {
        if (data.entries && data.entries.length > 0) {
            let options: ChartDropdownOption[] = null;
            let globalOption = this.generateGlobal(data.entries);
            if (globalOption) {
                options = [globalOption];
                options = options.concat(data.entries.map<ChartDropdownOption>(x => this.generateOptionData(x)).filter(x => x != null)
                    .sort((a, b) => (a.text ? a.text.toLowerCase() : "") < (b.text ? b.text.toLowerCase() : "") ? -1 : 1));
                let now = moment();
                let diff = moment.duration(now.diff(moment(data.offersInNegotiationUpdateTimestamp)));
                if (diff.hours() < 2 && this.summaryData && updateRequested) {
                    this.messageDialog.open();
                }

                return options;
            } else {
                return this.getDefaultSummaryData();
            }
        } else {
            return this.getDefaultSummaryData();
        }
    }

    protected getDefaultSummaryData(): ChartDropdownOption[] {
        let global = new OffersInNegotiationData();
        global.name = "Todos";
        global.offersInNegotiation = [];

        return [this.generateOptionData(global)];
    }

    private generateGlobal(entries: OffersInNegotiationData[]): ChartDropdownOption {
        let global = new OffersInNegotiationData();

        let offerArray = [];
        entries.forEach((entry) => {
            entry.offersInNegotiation.forEach((offer) => offerArray.push(offer));
        });

        global.name = "Todos";
        global.offersInNegotiation = offerArray;
        global.offersInNegotiationCount = offerArray.length;

        return this.generateOptionData(global);
    }

    private generateOptionData(entry: OffersInNegotiationData): ChartDropdownOption {
        let now = moment();
        let offersByDate = entry.offersInNegotiation.reduce<{ lessThanThreeMonths: OffersInNegotiationDetail[]; threeMonthsAndUp: OffersInNegotiationDetail[]; }>((acc, offer) => {

            if (moment.duration(now.diff(moment(offer.date))).months() < 2) {
                acc.lessThanThreeMonths.push(offer);

            } else {

                acc.threeMonthsAndUp.push(offer);
            }
            return acc;
        }, { lessThanThreeMonths: [], threeMonthsAndUp: [] });

        let accInit = {};
        accInit[1] = { segment: 1, count: 0 };
        accInit[2] = { segment: 2, count: 0 };
        accInit[3] = { segment: 3, count: 0 };
        accInit[4] = { segment: 4, count: 0 };

        let lessThanThreeMonthsSegmented = offersByDate.lessThanThreeMonths.reduce<{ [key: number]: { segment: number, count: number }; }>((acc, offer) => {
            let segment = Number.parseInt(offer.segment);
            if (acc[segment]) {
                acc[segment].count++;
            } else {
                acc[segment] = { segment: segment, count: 1 };
            }
            return acc;
        }, accInit);

        let lessThanThreeMonthsProcessed: { segment: number, count: number }[] = [];
        for (let key in lessThanThreeMonthsSegmented) {
            lessThanThreeMonthsProcessed.push(lessThanThreeMonthsSegmented[key]);
        }
        lessThanThreeMonthsProcessed = lessThanThreeMonthsProcessed.sort((a, b) => a.segment - b.segment);

        accInit = {};
        accInit[1] = { segment: 1, count: 0 };
        accInit[2] = { segment: 2, count: 0 };
        accInit[3] = { segment: 3, count: 0 };
        accInit[4] = { segment: 4, count: 0 };

        let threeMonthsAndUpSegmented = offersByDate.threeMonthsAndUp.reduce<{ [key: number]: { segment: number, count: number }; }>((acc, offer) => {
            let segment = Number.parseInt(offer.segment);
            if (acc[segment]) {
                acc[segment].count++;
            } else {
                acc[segment] = { segment: segment, count: 1 };
            }
            return acc;
        }, accInit);

        let threeMonthsAndUpProcessed: { segment: number, count: number }[] = [];
        for (let key in threeMonthsAndUpSegmented) {
            threeMonthsAndUpProcessed.push(threeMonthsAndUpSegmented[key]);
        }
        threeMonthsAndUpProcessed = threeMonthsAndUpProcessed.sort((a, b) => a.segment - b.segment);


        let option = new ChartDropdownOption();
        option.text = entry.name;
        option.value = new OffersInNegotiationEvolutionDOData(new BarChartData(
            ["S1", "S2", "S3", "S4"],
            [
                new BarChartDataset("2 meses ({0})".format(lessThanThreeMonthsProcessed.map(x => x.count).reduce((a, b) => a + b, 0).toString()),
                    lessThanThreeMonthsProcessed.map(x => x.count)),
                new BarChartDataset("+ 2 meses ({0})".format(threeMonthsAndUpProcessed.map(x => x.count).reduce((a, b) => a + b, 0).toString()),
                    threeMonthsAndUpProcessed.map(x => x.count)),
            ])
        );

        return option;
    }

    protected extractUpdateTime(data: OffersInNegotiationServiceData): Date {
        const MIN_DATE = moment("1970-01-01");
        let date = MIN_DATE;

        let test = moment().toISOString();
        let now = moment(test).tz("Etc/GMT");

        data.entries.forEach(x => {
            date = moment.max(date, moment(x.offersInNegotiationUpdateTimestamp.toString()));
        });

        if (date == MIN_DATE) return null;
        else  return new Date(date.toString());
    }

    protected processDetailData(data: OffersInNegotiationServiceData, args: any): OffersInNegotiationDODetailData {
        if (args && args.filter && args.filter.wholeOffice) {
            let columnDefinitions = [
                new TextColumnDefinition("Razón social"),
                new TextColumnDefinition("Segmento"),
                new TextColumnDefinition("Fecha"),
                new TextColumnDefinition("Potencial"),
                new TextColumnDefinition("Margen"),
                new TextColumnDefinition("Consultor", null, true)
            ];

            let tabledata = [];
            let thisWeek = moment().isoWeek();
            for (let entry of (data.entries || [])) {
                let offers = (entry.offersInNegotiation || [])
                    .filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek)
                    .sort(function (a, b) {
                        if (a.date == b.date) {
                            if (a.segment > b.segment) {
                                return 1;
                            }
                            if (a.segment < b.segment) {
                                return -1;
                            }
                            return 0;
                        }
                        else {
                            if (a.date > b.date) {
                                return 1;
                            }
                            if (a.date < b.date) {
                                return -1;
                            }
                            // a must be equal to b
                            return 0;
                        }
                    });

                for (let offer of offers) {
                    tabledata.push([
                        offer.trading_name,
                        "S" + offer.segment,
                        moment(offer.date).format("DD/MM/YYYY"),
                        offer.potential,
                        offer.min_margin,
                        entry.name
                    ]);
                }
            }

            return new OffersInNegotiationDODetailData(columnDefinitions, tabledata);
        } else {
            if (data.consultantEntry) {
                let columnDefinitions = [
                    new TextColumnDefinition("Razón social"),
                    new TextColumnDefinition("Segmento"),
                    new TextColumnDefinition("Fecha"),
                    new TextColumnDefinition("Potencial"),
                    new TextColumnDefinition("Margen")
                ];

                let tabledata = [];
                let thisWeek = moment().isoWeek();

                let offers = (data.consultantEntry.offersInNegotiation || [])
                    .filter(x => moment(x.updateTimestamp).isoWeek() == thisWeek);

                for (let offer of offers) {
                    tabledata.push([
                        offer.trading_name,
                        "S" + offer.segment,
                        moment(offer.date).format("DD/MM/YYYY"),
                        offer.potential,
                        offer.min_margin
                    ]);
                }

                tabledata = tabledata.sort(function (a, b) {
                    let dateA = a[2];
                    let dateB = b[2];
                    let segmentA = a[1];
                    let segmentB = b[1];
                    if (dateA == dateB) {
                        if (segmentA > segmentB) {
                            return 1;
                        }
                        if (segmentA < segmentB) {
                            return -1;
                        }
                        return 0;
                    }
                    else {
                        if (dateA > dateB) {
                            return 1;
                        }
                        if (dateA < dateB) {
                            return -1;
                        }
                        // a must be equal to b
                        return 0;
                    }
                })

                return new OffersInNegotiationDODetailData(columnDefinitions, tabledata);
            } else {
                return this.getDefaultDetailData();
            }
        }
    }

    protected getDefaultDetailData() {
        let columnDefinitions = [
            new TextColumnDefinition("Razón social"),
            new TextColumnDefinition("Segmento"),
            new TextColumnDefinition("Fecha"),
            new TextColumnDefinition("Potencial"),
            new TextColumnDefinition("Margen")
        ];

        return new OffersInNegotiationDODetailData(columnDefinitions, []);
    }

    protected performDetailAction(): void {
        if (this.detailDialog) this.detailDialog.open();
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}
